module.exports = __webpack_public_path__ + "img/ExitusMujer-BocetoCalle.e2baca35.png";